module.exports = __webpack_public_path__ + "static/Jira-66a71ba7ecbbea48f61fd0d109849bb9.png";